/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'template-mes': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M896 128v768H128V128h768M1024 0H0v1024h1024V0z"/><path pid="1" d="M128 320h768v64H128v-64zM192 192h192v64H192v-64zM192 448h640v128H192V448zM192 704h640v128H192V704z"/>'
  }
})
